module.exports = __webpack_public_path__ + "static/key-projectwarlock-94714fd5ec42902bca0c722e051986cf.webp";